export const PUBLIC_URL = process.env.PUBLIC_URL || ''

export const ROUTER_BASENAME = (() => {
  if (!PUBLIC_URL) {
    return ''
  } else if (/^(\/|https?:\/\/)/.test(PUBLIC_URL)) {
    const link = document.createElement('a') as HTMLAnchorElement
    link.href = PUBLIC_URL
    const path = link.pathname
    return path.endsWith('/') ? path.substr(0, path.length - 1) : path
  } else {
    // tslint:disable-next-line
    console.warn(
      new Error(`Invalidated PUBLIC_URL ${JSON.stringify(PUBLIC_URL)}`),
    )
    return ''
  }
})()
